export function getReportHeaders(accountId) {
    return new Headers({ "accountid": accountId });
}
